import { ActionTree } from 'vuex';
import RootState from '@/store/RootState';
import { FiltersState } from './typings';
import { Filter } from '@/services/filters';
import { SET_FILTER, RESET_FILTERS } from '@/store/mutation-types';

const actions: ActionTree<FiltersState, RootState> = {
  set: ({commit}, f: Filter): void => {
    commit(SET_FILTER, f);
  },
  reset: ({commit}): void => {
    commit(RESET_FILTERS);
  },
};

export default actions;
